import "./AdaptiveLoader.css"

import { memo, ReactNode } from "react"

import { Color } from "@/theme/types"

const ANIMATION_SPEED = 2
const BAR_NUMBER = 4
const bars: number[] = Array(BAR_NUMBER)
  .fill(null)
  .map((_, idx) => idx)

type LoaderType = "primary" | "secondary"

export const AdaptiveLoader = memo(function AdaptiveLoader({
  size,
  type,
  separation,
  speed,
  children,
  color,
  ariaLabel,
}: {
  ariaLabel?: string
  size: number | string
  type?: LoaderType
  separation?: number
  speed?: number
  color?: Color
  children?: ReactNode
}) {
  const sizeNum = Number(size)
  const barHeight = sizeNum * 0.7
  const barWidth = barHeight / 4
  const separationDistance =
    separation !== undefined ? separation : sizeNum / 12
  const moveDistance = barHeight / 3
  const totalBarWidth =
    barWidth * BAR_NUMBER + separationDistance * (BAR_NUMBER - 1)
  const extraWidth = sizeNum - totalBarWidth

  return (
    <svg
      width={sizeNum}
      height={sizeNum}
      role="progressbar"
      aria-label={ariaLabel}
    >
      {bars.map((idx) => (
        <rect
          className="animate-bounce-rect fill-(--text-primary)"
          type={type || "primary"}
          key={idx}
          height={barHeight}
          width={barWidth}
          x={extraWidth / 2 + idx * (barWidth + separationDistance)}
          color={color}
          style={
            {
              "--move-distance": `${moveDistance}px`,
              willChange: "transform",
              animationDuration: `${speed || ANIMATION_SPEED}s`,
              animationDelay: `${idx * ((speed || ANIMATION_SPEED) / 1.3 / BAR_NUMBER) - (speed || ANIMATION_SPEED) * 0.6}s`,
            } as React.CSSProperties & Record<string, string>
          }
        />
      ))}
      {children}
    </svg>
  )
})
